module.exports = __webpack_public_path__ + "static/media/prod11.8b0e4f95.jpg";